<modal-container
  #modal
  [isSmallModal]="true"
  [ignoreBackdropClick]="true"
  [hideCloseButton]="true"
  [isHideBtnHidden]="true"
>
  <ng-container class="modal-body-content">
    <div class="card">
      <loading-spinner [isLoading]="true"></loading-spinner>
    </div>
  </ng-container>
</modal-container>
